<template>
  <div class="content">
    <div class="explain" @click="toSettlePact">结算说明</div>
    <img :src="public_path + '/static/images/post_entry_icon@3x.png'" alt="" class="success">
    <p class="submit-success">当月收入</p>
    <p class="money"><span>￥</span>{{total_current_month}}</p>
    <p class="hint"><span>累计收入：{{total_amount}}元</span><span>已结算：{{cleared_amount}}元</span></p>
    <button class="btn" @click="toDetail">收入明细</button>
  </div>
</template>
<script>
import { getIncome } from '@/http/api'
export default {
  data () {
    return {
      cleared_amount: 0,
      total_current_month: 0,
      total_amount: 0,
      public_path: process.env.PUBLICK_PATH
    }
  },
  methods: {
    getIncome () {
      getIncome({token: localStorage.token}).then(res => {
        console.log(res)
        if (res.code === 0) {
          this.total_amount = res.data.total_amount
          this.total_current_month = res.data.total_current_month
          this.cleared_amount = res.data.cleared_amount
        }
      })
    },
    toDetail () {
      this.$router.push({
        path: '/incomebydev'
      })
    },
    toSettlePact () {
      this.$router.push({
        path: '/settlePact'
      })
    }
  },
  mounted () {
    this.getIncome()
  }
}
</script>
<style lang="scss" scoped>
.content {
  font-size: 0;
  color: #333;
  .explain {
    position: absolute;
    top: .3rem;
    right: .3rem;
    font-size: .26rem;
    color: rgba(2, 179, 137, 1);
  }
  .success {
    display: block;
    margin: 1rem auto auto;
    width: 2rem;
    height: 2rem;
  }
  .submit-success {
    font-size: .36rem;
    color: #02B389;
    text-align: center;
  }
  .money {
    font-size: .72rem;
    margin-top: .6rem;
    text-align: center;
    font-weight: 400;
    span {
      font-size: .42rem;
      font-weight: 400;
    }
  }
  .hint {
    font-size: .24rem;
    color: rgba(51, 51, 51, 0.5);
    margin-top: .33rem;
    text-align: center;
    span {
      margin-right: .5rem;
    }
  }
  .btn {
    display: block;
    width: 6.90rem;
    height: .90rem;
    border-radius: .45rem;
    border:2px solid rgba(2, 179, 137, 1);
    background: none;
    margin: 1.12rem auto;
    font-size: .32rem;
    color: #02B389;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/income/Income.vue